import React from "react";

const Dropdown = ({ title, data, name, value, onChange, disabled=false }) => {
  return (
    <div className="d-flex flex-column mb-3 px-4">
      <p className="semibold ">{title}</p>
      {/* <input
        className="r form1"
        type="text"
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
      ></input> */}
      <select
        title={title}
        name={name}
        onChange={onChange}
        className="form-select"
        value={value}
        disabled={disabled}
      >
        {data.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
      </select>
    </div>
  );
};

export default Dropdown;
